<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-card shadow="never">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  :label="$l('INDEX.goods_label_orderGoodsName') || '产品名称'"
                  prop="orderGoodsName"
                >
                  <el-input
                    clearable
                    v-model="formData.orderGoodsName"
                    :placeholder="
                      $l('INDEX.tips_goods_label_orderGoodsName') ||
                        '请输入产品名称'
                    "
                    type="text"
                    maxlength="100"
                    show-word-limit
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="
                    $l('INDEX.goods_label_orderGoodsNameEn') || '产品英文名称'
                  "
                  prop="orderGoodsNameEn"
                >
                  <el-input
                    clearable
                    v-model="formData.orderGoodsNameEn"
                    :placeholder="
                      $l('INDEX.tips_goods_label_orderGoodsNameEn') ||
                        '请输入产品英文名称'
                    "
                    type="text"
                    maxlength="100"
                    show-word-limit
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.goods_label_orderGoodsPattern') || '花型'"
                >
                  <el-input
                    clearable
                    v-model="formData.orderGoodsPattern"
                    :placeholder="
                      $l('INDEX.tips_goods_label_orderGoodsPattern') ||
                        '请输入花型'
                    "
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="
                    $l('INDEX.goods_label_orderGoodsPatternEn') ||
                      '花型英文名称'
                  "
                >
                  <el-input
                    clearable
                    v-model="formData.orderGoodsPatternEn"
                    :placeholder="
                      $l('INDEX.tips_goods_label_orderGoodsPatternEn') ||
                        '请输入花型英文名称'
                    "
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.label_master_category') || '主分类'"
                  prop="masterCategoryCode"
                >
                  <dict-select
                    :placeholder="$l('INDEX.tips_select_data') || '请选择'"
                    size="mini"
                    clearable
                    filterable
                    v-model="formData.masterCategoryCode"
                    :body="{ parentCode: 'ABSHome' }"
                    url="/master/masterCategory/select"
                    @change="updateCategoryCode"
                  ></dict-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.label_detail_category') || '明细分类'"
                  prop="categoryCode"
                >
                  <dict-select
                    :disabled="!formData.masterCategoryCode"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择'"
                    size="mini"
                    clearable
                    filterable
                    v-model="formData.categoryCode"
                    :body="queryCategoryParams"
                    url="/master/masterCategory/select"
                  ></dict-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.goods_label_orderGoodsUnit') || '产品单位'"
                  prop="orderGoodsUnit"
                >
                  <dict-select
                    clearable
                    :placeholder="
                      $l('INDEX.tips_goods_label_orderGoodsUnit') ||
                        '请选择单位'
                    "
                    size="mini"
                    v-model="formData.orderGoodsUnit"
                    filterable
                    url="/digitalCenter/common/dict/biz"
                    :body="orderGoodsUnitDictParams"
                  ></dict-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="
                    $l('INDEX.goods_label_orderGoodsEnglishSize') || '英文尺寸'
                  "
                >
                  <dict-select
                    clearable
                    :placeholder="
                      $l('INDEX.tips_goods_label_orderGoodsEnglishSize') ||
                        '请选择英文尺寸'
                    "
                    size="mini"
                    v-model="formData.orderGoodsEnglishSize"
                    filterable
                    url="/digitalCenter/common/dict/biz"
                    :body="englishSizeDictParams"
                    :selectedLabel.sync="formData.v_englishSize"
                  ></dict-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  :label="
                    $l('INDEX.order_goods_label_price') + ' ' + currencyUnit ||
                      '成本价' + ' ' + currencyUnit
                  "
                  prop="price"
                >
                  <el-input-number
                    v-model="formData.price"
                    :placeholder="
                      $l('INDEX.tips_goods_label_price') || '请输入成本价'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="999999"
                    :min="0"
                    :step="0.01"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="
                    $l('INDEX.order_goods_label_salePrice') +
                      ' ' +
                      salesCurrencyUnit || '售价' + ' ' + salesCurrencyUnit
                  "
                  prop="salePrice"
                >
                  <el-input-number
                    v-model="formData.salePrice"
                    :placeholder="
                      $l('INDEX.tips_goods_label_salePrice') || '请输入售价'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="999999"
                    :min="0"
                    :step="0.01"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="
                    $l('INDEX.order_goods_label_netSalePrice') || '去佣金后单价'
                  "
                  prop="netSalePrice"
                >
                  <el-input-number
                    v-model="formData.netSalePrice"
                    :placeholder="
                      commissionVisible
                        ? $l('INDEX.form_label_automatic_system_generation') ||
                          '自动生成'
                        : $l('INDEX.tips_please_enter_the_netSalePrice') ||
                          '请输入去佣金后单价'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="999999"
                    :min="0"
                    :step="0.0001"
                    :disabled="commissionVisible"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.goods_label_isGroup') || '是否套装'"
                  prop="isGroup"
                >
                  <el-select
                    clearable
                    v-model="formData.isGroup"
                    :placeholder="
                      $l('INDEX.tips_goods_label_isGroup') || '请选择是否是套装'
                    "
                    size="mini"
                    style="width:100%"
                  >
                    <el-option
                      :label="$l('INDEX.YES') || '是'"
                      value="Y"
                    ></el-option>
                    <el-option
                      :label="$l('INDEX.NO') || '否'"
                      value="N"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.goods_label_inPackageQty') || '装箱入数'"
                  prop="inPackageQty"
                >
                  <el-input-number
                    v-model="formData.inPackageQty"
                    :placeholder="
                      $l('INDEX.tips_goods_label_inPackageQty') ||
                        '请输入装箱入数'
                    "
                    controls-position="right"
                    style="width:100%"
                    :max="9999"
                    :min="1"
                    :step-strictly="true"
                    :step="1"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="16">
          <GoodsAttributes
            :disabled="disabled"
            :tableData="tableData"
            ref="goodsAttributes"
          />
          <GoodsSpecDialog
            :disabled="disabled"
            :changeOrderGoodsCode="changeOrderGoodsCode"
            :orderGoodsCode="orderGoodsCode"
            :changeOrderCode="changeOrderCode"
            ref="goodsSpec"
          />
        </el-col>
      </el-row>
      <div class="d-flex justify-content-end mt-2">
        <el-button plain size="small" @click="cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import GoodsAttributes from '../goods-attributes-table/main.vue'
import GoodsSpecDialog from '../goods-spec-dialog/table'
export default {
  mixins: [EditLoading],
  components: { GoodsAttributes, GoodsSpecDialog },
  props: {
    disabled: Boolean,
    changeOrderGoodsCode: { type: String, default: '' },
    changeOrderCode: { type: String, default: '' },
    orderGoodsCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      tableData: [{}],
      patternOptions: [],
      englishSizeDictParams: { dictType: 'englishSize' },
      orderGoodsUnitDictParams: { dictType: 'orderGoodsUnit' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      currencyUnit: '',
      salesCurrencyUnit: '',
      commissionVisible: false,
      queryCategoryParams: { parentCode: 'x' },
      rules: {
        orderGoodsName: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_orderGoodsName') ||
              '请输入产品名称',
            trigger: 'blur',
          },
        ],
        orderGoodsNameEn: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_orderGoodsNameEn') ||
              '请输入英文名称',
            trigger: 'blur',
          },
        ],
        masterCategoryCode: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_select_master_categoryCode') ||
              '请选择主分类',
            trigger: 'change',
          },
        ],
        englishSize: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_orderGoodsEnglishSize') ||
              '请选择英文尺寸',
            trigger: 'change',
          },
        ],
        orderGoodsUnit: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_orderGoodsUnit') || '请选择单位',
            trigger: 'change',
          },
        ],
        price: [
          {
            required: true,
            message: this.$l('INDEX.tips_goods_label_price') || '请输入成本价',
            trigger: 'blur',
          },
        ],
        salePrice: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_salePrice') || '请输入售价',
            trigger: 'blur',
          },
        ],
        isGroup: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_isGroup') || '请选择是否是套装',
            trigger: 'change',
          },
        ],
        inPackageQty: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_inPackageQty') ||
              '请输入装箱入数',
            trigger: 'blur',
          },
        ],
        netSalePrice: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_please_enter_the_netSalePrice') ||
              '请输入去佣金后单价',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    this.getData()
    this.getChangeOrderInfo()
  },
  methods: {
    getData() {
      if (!this.changeOrderGoodsCode) return
      this.$api
        .changeOrderGoodsCopyDetailApi({
          changeOrderGoodsCode: this.changeOrderGoodsCode,
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          this.formData = res.body
          if (
            this.formData.changeOrderGoodsColorList &&
            this.formData.changeOrderGoodsColorList.length > 0
          ) {
            // console.log(this.formData.changeOrderGoodsColorList)
            this.tableData = this.formData.changeOrderGoodsColorList
          } else {
            this.tableData = [
              {
                orderGoodsColor: this.formData.orderGoodsColor,
              },
            ]
          }
          this.queryCategoryParams = {
            parentCode: this.formData.masterCategoryCode,
          }
        })
    },
    getChangeOrderInfo() {
      this.$api
        .changeOrderInfoDetailApi({ changeOrderCode: this.changeOrderCode })
        .then((res) => {
          const data = res.body
          this.currencyUnit = data.currencyUnit
          this.salesCurrencyUnit = data.salesCurrencyUnit
          if (data.commissionType == 'A') {
            this.commissionVisible = true
            this.rules.netSalePrice[0].required = false
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (
        (this.formData.netSalePrice > this.formData.salePrice ||
          !this.formData.netSalePrice) &&
        !this.commissionVisible
      ) {
        this.$message.error(
          this.$l('INDEX.tips_netSalePrice_cannot_be_greater_than_salePrice') ||
            '去佣金后单价必须大于 0 并且小于等于售价'
        )
        return
      }

      const attributes = await this.$refs.goodsAttributes.getTableData()
      if (!attributes) return

      const goodsSpec = await this.$refs.goodsSpec.getTableData()
      if (!goodsSpec) return

      this.formData.changeOrderGoodsCode = ''
      const parms = {
        ...this.formData,
        changeOrderCode: this.changeOrderCode,
        changeOrderGoodsColorList: attributes,
        changeOrderGoodsSpecList: goodsSpec,
      }
      this.loadingOpen()
      this.$api
        .changeOrderGoodsAddSaveApi(parms)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    updateCategoryCode() {
      this.formData.categoryCode = ''
      this.queryCategoryParams = {
        parentCode: this.formData.masterCategoryCode,
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
